var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { Loader } from '../loader/loader.js';
import MapAPI from './map-api.js';
import './map.css';
let Map = class Map extends PureComponent {
    getFrameStyle() {
        const { height } = this.props;
        return {
            border: 0,
            height: `${height}px`,
            width: '100%',
        };
    }
    render() {
        const { loading, providerUrl, visible } = this.props;
        if (!visible) {
            return null;
        }
        return (React.createElement("div", { className: "c-map" }, loading
            ? React.createElement(Loader, { className: "c-map__loader", size: 64 })
            : React.createElement("iframe", { frameBorder: "0", src: providerUrl, style: this.getFrameStyle() })));
    }
};
Map.propTypes = {
    height: number,
    loading: bool,
    providerUrl: string,
    visible: bool,
};
Map.defaultProps = {
    height: 200,
    providerUrl: 'https://www.google.com/maps/embed/v1/place?q=place_id=ChIJ3xaSbEkZ35QRx26m5q62zKI&key=AIzaSyCnMCTUecQ1iAph2t_QqpQilHVjuBcyiSg',
    visible: true,
};
Map = __decorate([
    AwesomeComponent({ api: MapAPI, type: ComponentType.DATA_DISPLAY })
], Map);
export default Map;
//# sourceMappingURL=map.js.map